import { MapfreCardComponent } from '../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute , RouterModule  } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreCardComponent],
  selector: 'app-billing-stuffer',
  templateUrl: './billing-stuffer.component.html',
  styleUrls: ['./billing-stuffer.component.scss']
})
export class BillingStufferComponent implements OnInit {
  isPolicyAlreadyEnrolled: boolean;
  
  constructor(private activatedRoute: ActivatedRoute) {
    this.isPolicyAlreadyEnrolled = false;
   }

  getQueryParam() {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      if (queryParams['isAlreadyEnrolled'] === "true") {
        this.isPolicyAlreadyEnrolled = true;
      }
    })
  }
  ngOnInit(): void {
    this.getQueryParam();
  }
}
